import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-plus-o",
  "use": "icon-plus-o-usage",
  "viewBox": "0 0 15 15",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 15 15\" id=\"icon-plus-o\">\n    <path fill=\"currentColor\" d=\"M7.5 0C3.375 0 0 3.375 0 7.5S3.375 15 7.5 15 15 11.625 15 7.5 11.625 0 7.5 0zm3 8.25H8.25v2.25c0 .45-.3.75-.75.75s-.75-.3-.75-.75V8.25H4.5c-.45 0-.75-.3-.75-.75s.3-.75.75-.75h2.25V4.5c0-.45.3-.75.75-.75s.75.3.75.75v2.25h2.25c.45 0 .75.3.75.75s-.3.75-.75.75z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol